import Vue from "vue";
import VueRouter from "vue-router";
import content from "../pages/common/Content.vue"
import editorial from "../pages/Editorial.vue"
Vue.use(VueRouter);

const routes = [{
        path: "/main",
        name: "main",
        component: content,
        children: [{
                path: '/editorial',
                name: 'editorial',
                component: editorial,
                meta: {
                    title: 'Editorial',
                    breadcrumbs: [
                        { to: '/', text: 'Editorial' }
                    ]
                }
            }
        ]
    },
    {
        path: '/',
        redirect: '/editorial'
    }
]

var router = new VueRouter({
    mode: 'history',
    routes
})


export default router;